import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from 'Data/ReduxViewModels/MessageLink';

interface IMessageLinkTargetProps {
  id: string;
}

/**
 * Component for Results Sections to link to, so a user can see the origin of a message. Not visible to the user.
 * @param id Unique id for links to target.
 */
export const MessageLinkTarget: React.FC<IMessageLinkTargetProps> = ({ id }) => {
  if (id === undefined || id === null) throw new Error('Cannot create a message link with no id.');

  const dispatch = useDispatch();
  const { addLinkTargetId, deleteLinkTargetId } = actions;

  // Effectively a new component if the id changes.
  useEffect(() => {
    // Message links should only be for API error messages, which have to be strings. Skip anything else.
    dispatch(addLinkTargetId(id));

    return () => {
      dispatch(deleteLinkTargetId(id));
    };
  }, [dispatch, addLinkTargetId, deleteLinkTargetId, id]);

  return <span id={`message-link-${id}`} />;
};
